
/***
 * Converts the passed text to an Australian E.164 phone number if possible
 * otherwise returns the passed value
 *
 * @param text
 * @returns {*}
 */
export default function e164ify(text) {
    // Strip all non-digits from the text
    let num = text.toString().replace(/\D/g,'');
    // Strip any leading 0
    num = num.replace(/^0/g, '');
    // If we have 9 digits, treat it as a phone number
    if (num.length === 9) {
        return '+61' + num;
    }
    // If we have 11 digits and it starts with 61, it's already an E164 number
    if (num.length === 11 && num.startsWith('61')) {
        return '+' + num
    }
    return text;
}
